import { defaultIconProps, IconProps } from './IconProps';

export const IconLock03: import('react').FC<IconProps> = ({ size, color, strokeWidth = 1.5, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M14.1663 9.16667V6.66667C14.1663 4.36548 12.3009 2.5 9.99967 2.5C7.69849 2.5 5.83301 4.36548 5.83301 6.66667V9.16667M7.33301 17.5H12.6663C14.0665 17.5 14.7665 17.5 15.3013 17.2275C15.7717 16.9878 16.1542 16.6054 16.3939 16.135C16.6663 15.6002 16.6663 14.9001 16.6663 13.5V13.1667C16.6663 11.7665 16.6663 11.0665 16.3939 10.5317C16.1542 10.0613 15.7717 9.67883 15.3013 9.43915C14.7665 9.16667 14.0665 9.16667 12.6663 9.16667H7.33301C5.93288 9.16667 5.23281 9.16667 4.69803 9.43915C4.22763 9.67883 3.84517 10.0613 3.60549 10.5317C3.33301 11.0665 3.33301 11.7665 3.33301 13.1667V13.5C3.33301 14.9001 3.33301 15.6002 3.60549 16.135C3.84517 16.6054 4.22763 16.9878 4.69803 17.2275C5.23281 17.5 5.93288 17.5 7.33301 17.5Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconLock03.defaultProps = defaultIconProps;
